import { render, staticRenderFns } from "./ManageQuotaRate.vue?vue&type=template&id=5ba0a35f&scoped=true"
import script from "./ManageQuotaRate.vue?vue&type=script&lang=js"
export * from "./ManageQuotaRate.vue?vue&type=script&lang=js"
import style0 from "./ManageQuotaRate.vue?vue&type=style&index=0&id=5ba0a35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0a35f",
  null
  
)

export default component.exports